module.exports = __webpack_public_path__ + "static/media/blood-bank-banner.c4396fe5.png";